import Service from "../../Services";

const Contact = {
  namespaced : true,
  state : {
    form : {
      branch_id : '',
      tcdc_mini_id : '',
      title_th : '',
      title_en : '',
      description_th : '',
      description_en : '',
      contact_email : '',
    }
  },
  mutations : {
    GET_FORM:(state,res)=>{
      state.form = res;
    },
    CLEAR_FORM_DATA :(state)=>{
      state.form = {
        branch_id : '',
        tcdc_mini_id : '',
        title_th : '',
        title_en : '',
        description_th : '',
        description_en : '',
        contact_email : '',
      }
    }
  },
  actions : {
    getContact({commit},page){
      return Service.ContactAPI.getContact(page);
    },
    showContact({commit},id){
      return Service.ContactAPI.showContact(id);
    },
    saveContact({commit},{id,data}){
      if(id){
        return Service.ContactAPI.updateContact(id,data);
      }else{
        return Service.ContactAPI.createContact(data);
      }
    },
    deleteContact({commit},id){
      return Service.ContactAPI.deleteContact(id);
    },
    setFormContact({commit},res){
      commit('GET_FORM',res);
    },
    clearFormData({commit}){
      commit('CLEAR_FORM_DATA');
    }
  },
}
export default Contact
